module.exports = __webpack_public_path__ + "example_portfolios2.svg?bcc2847d8022e6f3286ec0c454216000";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/portfoliomanager/example_portfolios2.svg
// module id = 62
// module chunks = 0